import get from 'lodash/get';

interface Color {
    front: string;
    back: string;
}

interface Colors {
    [index: string]: Color;
}

export const bookingStatus = {
    pending: 'En attente',
    accepted: 'Acceptée',
    extension_24h: 'Prorogation de 24h',
    extension_48h: 'Prorogation de 45h',
    expired: 'Périmée',
    declined: 'Refusée',
    canceled: 'Annulée',
    waiting: 'Att Ret Prom.'
};

export const bookingStatusColors: Colors = {
    pending: {
        front: 'white',
        back: '#6CA6D9',
    },
    accepted: {
        front: 'white',
        back: '#C37A9D',
    },
    extension_24h: {
        front: 'white',
        back: '#E26667',
    },
    extension_48h: {
        front: 'white',
        back: '#E26667',
    },
    expired: {
        front: 'white',
        back: '#F8B170',
    },
    declined: {
        front: 'white',
        back: '#F2C246',
    },
    canceled: {
        front: 'white',
        back: '#B3D6A9',
    },
};

export const formatBookingStatus = (value: string) => {
    return get(bookingStatus, value, value);
};